/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  PerfDetailsCompRateProtocolGetComplianceRateOverTimeCsvRequest,
  PerfDetailsCompRateProtocolGetComplianceRateOverTimeRequest,
  PerfDetailsCompRateProtocolGetComplianceRateOverTimeResponse,
  PerfDetailsCompRateProtocolGetComplianceRateRequest,
  PerfDetailsCompRateProtocolGetComplianceRateResponse,
  PerfDetailsCompRateProtocolGetComplianceRateTopCsvRequest,
  PerfDetailsCompRateProtocolGetComplianceRateTopDataRequest,
  PerfDetailsCompRateProtocolGetComplianceRateTopDataResponse,
  PerfDetailsEnfAnalysisProtocolGetListingCountByAnalysisTypeRequest,
  PerfDetailsEnfAnalysisProtocolGetListingCountByAnalysisTypeResponse,
  PerfDetailsEnfAnalysisProtocolGetListingsOverTimeCsvRequest,
  PerfDetailsEnfAnalysisProtocolGetListingsOverTimeRequest,
  PerfDetailsEnfAnalysisProtocolGetListingsOverTimeResponse,
  PerfDetailsEnfAnalysisProtocolGetTopAssetCsvRequest,
  PerfDetailsEnfAnalysisProtocolGetTopAssetDataRequest,
  PerfDetailsEnfAnalysisProtocolGetTopAssetDataResponse,
  PerfDetailsEnfAnalysisProtocolGetTopChannelCsvRequest,
  PerfDetailsEnfAnalysisProtocolGetTopChannelDataRequest,
  PerfDetailsEnfAnalysisProtocolGetTopChannelDataResponse,
  PerfDetailsEnfAnalysisProtocolGetTopDomainCsvRequest,
  PerfDetailsEnfAnalysisProtocolGetTopDomainDataRequest,
  PerfDetailsEnfAnalysisProtocolGetTopDomainDataResponse,
  PerfDetailsOffenderProtocolGetChannelFilterListRequest,
  PerfDetailsOffenderProtocolGetChannelFilterListResponse,
  PerfDetailsOffenderProtocolGetOffendersRequest,
  PerfDetailsOffenderProtocolGetOffendersResponse,
  PerfDetailsOffenderProtocolGetTopInfringingDomainsCsvRequest,
  PerfDetailsOffenderProtocolGetTopInfringingDomainsRequest,
  PerfDetailsOffenderProtocolGetTopInfringingDomainsResponse,
  PerfDetailsOffenderProtocolGetTopInfringingProfilesCsvRequest,
  PerfDetailsOffenderProtocolGetTopInfringingProfilesRequest,
  PerfDetailsOffenderProtocolGetTopInfringingProfilesResponse,
  PerformanceProtocolGetComplianceRateRequest,
  PerformanceProtocolGetComplianceRateResponse,
  PerformanceProtocolGetComplianceRateTopChannelsRequest,
  PerformanceProtocolGetComplianceRateTopChannelsResponse,
  PerformanceProtocolGetOffenderDataRequest,
  PerformanceProtocolGetOffenderDataResponse,
  PerformanceProtocolGetRemovedListingsOverTimeSearchEngineRequest,
  PerformanceProtocolGetRemovedListingsOverTimeSearchEngineResponse,
  PerformanceProtocolGetRemovedListingsOverTimeSocialMediaRequest,
  PerformanceProtocolGetRemovedListingsOverTimeSocialMediaResponse,
  PerformanceProtocolGetTopInfringingDomainsRequest,
  PerformanceProtocolGetTopInfringingDomainsResponse,
  PerformanceProtocolGetTopInfringingProfilesRequest,
  PerformanceProtocolGetTopInfringingProfilesResponse,
  PerformanceProtocolReportGetListRequest,
  PerformanceProtocolReportGetListResponse,
  PiracyCommonProtocolFileResponse,
} from './data-contracts';
import { ContentType, HttpClient, RequestParams } from './http-client';

export class Performance<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * No description
   *
   * @tags Performance
   * @name ListingsTimeSearchCreate
   * @request POST:/performance/listings-time-search
   */
  listingsTimeSearchCreate = (
    data: PerformanceProtocolGetRemovedListingsOverTimeSearchEngineRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<PerformanceProtocolGetRemovedListingsOverTimeSearchEngineResponse, any>({
      path: `/performance/listings-time-search`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Performance
   * @name ListingsTimeSocialCreate
   * @request POST:/performance/listings-time-social
   */
  listingsTimeSocialCreate = (
    data: PerformanceProtocolGetRemovedListingsOverTimeSocialMediaRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<PerformanceProtocolGetRemovedListingsOverTimeSocialMediaResponse, any>({
      path: `/performance/listings-time-social`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Performance
   * @name TopInfringingDomainsCreate
   * @request POST:/performance/top-infringing-domains
   */
  topInfringingDomainsCreate = (data: PerformanceProtocolGetTopInfringingDomainsRequest, params: RequestParams = {}) =>
    this.http.request<PerformanceProtocolGetTopInfringingDomainsResponse, any>({
      path: `/performance/top-infringing-domains`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Performance
   * @name TopInfringingProfilesCreate
   * @request POST:/performance/top-infringing-profiles
   */
  topInfringingProfilesCreate = (
    data: PerformanceProtocolGetTopInfringingProfilesRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<PerformanceProtocolGetTopInfringingProfilesResponse, any>({
      path: `/performance/top-infringing-profiles`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Performance
   * @name OffenderDataCreate
   * @request POST:/performance/offender-data
   */
  offenderDataCreate = (data: PerformanceProtocolGetOffenderDataRequest, params: RequestParams = {}) =>
    this.http.request<PerformanceProtocolGetOffenderDataResponse, any>({
      path: `/performance/offender-data`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Performance
   * @name ComplianceRateCreate
   * @request POST:/performance/compliance-rate
   */
  complianceRateCreate = (data: PerformanceProtocolGetComplianceRateRequest, params: RequestParams = {}) =>
    this.http.request<PerformanceProtocolGetComplianceRateResponse, any>({
      path: `/performance/compliance-rate`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Performance
   * @name ComplianceRateTopCreate
   * @request POST:/performance/compliance-rate-top
   */
  complianceRateTopCreate = (
    data: PerformanceProtocolGetComplianceRateTopChannelsRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<PerformanceProtocolGetComplianceRateTopChannelsResponse, any>({
      path: `/performance/compliance-rate-top`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Performance
   * @name ReportListCreate
   * @request POST:/performance/report/list
   */
  reportListCreate = (data: PerformanceProtocolReportGetListRequest, params: RequestParams = {}) =>
    this.http.request<PerformanceProtocolReportGetListResponse, any>({
      path: `/performance/report/list`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Performance
   * @name DetailsEnfAnalysisCreate
   * @request POST:/performance/details/enf-analysis
   */
  detailsEnfAnalysisCreate = (
    data: PerfDetailsEnfAnalysisProtocolGetListingsOverTimeRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<PerfDetailsEnfAnalysisProtocolGetListingsOverTimeResponse, any>({
      path: `/performance/details/enf-analysis`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Performance
   * @name DetailsEnfAnalysisTopAssetCreate
   * @request POST:/performance/details/enf-analysis/top-asset
   */
  detailsEnfAnalysisTopAssetCreate = (
    data: PerfDetailsEnfAnalysisProtocolGetTopAssetDataRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<PerfDetailsEnfAnalysisProtocolGetTopAssetDataResponse, any>({
      path: `/performance/details/enf-analysis/top-asset`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Performance
   * @name DetailsEnfAnalysisTopDomainCreate
   * @request POST:/performance/details/enf-analysis/top-domain
   */
  detailsEnfAnalysisTopDomainCreate = (
    data: PerfDetailsEnfAnalysisProtocolGetTopDomainDataRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<PerfDetailsEnfAnalysisProtocolGetTopDomainDataResponse, any>({
      path: `/performance/details/enf-analysis/top-domain`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Performance
   * @name DetailsEnfAnalysisTopChannelCreate
   * @request POST:/performance/details/enf-analysis/top-channel
   */
  detailsEnfAnalysisTopChannelCreate = (
    data: PerfDetailsEnfAnalysisProtocolGetTopChannelDataRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<PerfDetailsEnfAnalysisProtocolGetTopChannelDataResponse, any>({
      path: `/performance/details/enf-analysis/top-channel`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Performance
   * @name DetailsEnfAnalysisCountCreate
   * @request POST:/performance/details/enf-analysis/count
   */
  detailsEnfAnalysisCountCreate = (
    data: PerfDetailsEnfAnalysisProtocolGetListingCountByAnalysisTypeRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<PerfDetailsEnfAnalysisProtocolGetListingCountByAnalysisTypeResponse, any>({
      path: `/performance/details/enf-analysis/count`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Performance
   * @name DetailsEnfAnalysisCsvCreate
   * @request POST:/performance/details/enf-analysis/csv
   */
  detailsEnfAnalysisCsvCreate = (
    data: PerfDetailsEnfAnalysisProtocolGetListingsOverTimeCsvRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<PiracyCommonProtocolFileResponse, any>({
      path: `/performance/details/enf-analysis/csv`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Performance
   * @name DetailsEnfAnalysisTopAssetCsvCreate
   * @request POST:/performance/details/enf-analysis/top-asset/csv
   */
  detailsEnfAnalysisTopAssetCsvCreate = (
    data: PerfDetailsEnfAnalysisProtocolGetTopAssetCsvRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<PiracyCommonProtocolFileResponse, any>({
      path: `/performance/details/enf-analysis/top-asset/csv`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Performance
   * @name DetailsEnfAnalysisTopChannelCsvCreate
   * @request POST:/performance/details/enf-analysis/top-channel/csv
   */
  detailsEnfAnalysisTopChannelCsvCreate = (
    data: PerfDetailsEnfAnalysisProtocolGetTopChannelCsvRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<PiracyCommonProtocolFileResponse, any>({
      path: `/performance/details/enf-analysis/top-channel/csv`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Performance
   * @name DetailsEnfAnalysisTopDomainCsvCreate
   * @request POST:/performance/details/enf-analysis/top-domain/csv
   */
  detailsEnfAnalysisTopDomainCsvCreate = (
    data: PerfDetailsEnfAnalysisProtocolGetTopDomainCsvRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<PiracyCommonProtocolFileResponse, any>({
      path: `/performance/details/enf-analysis/top-domain/csv`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Performance
   * @name DetailsCompRateCreate
   * @request POST:/performance/details/comp-rate
   */
  detailsCompRateCreate = (data: PerfDetailsCompRateProtocolGetComplianceRateRequest, params: RequestParams = {}) =>
    this.http.request<PerfDetailsCompRateProtocolGetComplianceRateResponse, any>({
      path: `/performance/details/comp-rate`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Performance
   * @name DetailsCompRateOverTimeCreate
   * @request POST:/performance/details/comp-rate/over-time
   */
  detailsCompRateOverTimeCreate = (
    data: PerfDetailsCompRateProtocolGetComplianceRateOverTimeRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<PerfDetailsCompRateProtocolGetComplianceRateOverTimeResponse, any>({
      path: `/performance/details/comp-rate/over-time`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Performance
   * @name DetailsCompRateTopChannelCreate
   * @request POST:/performance/details/comp-rate/top-channel
   */
  detailsCompRateTopChannelCreate = (
    data: PerfDetailsCompRateProtocolGetComplianceRateTopDataRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<PerfDetailsCompRateProtocolGetComplianceRateTopDataResponse, any>({
      path: `/performance/details/comp-rate/top-channel`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Performance
   * @name DetailsCompRateOverTimeCsvCreate
   * @request POST:/performance/details/comp-rate/over-time/csv
   */
  detailsCompRateOverTimeCsvCreate = (
    data: PerfDetailsCompRateProtocolGetComplianceRateOverTimeCsvRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<PiracyCommonProtocolFileResponse, any>({
      path: `/performance/details/comp-rate/over-time/csv`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Performance
   * @name DetailsCompRateTopChannelCsvCreate
   * @request POST:/performance/details/comp-rate/top-channel/csv
   */
  detailsCompRateTopChannelCsvCreate = (
    data: PerfDetailsCompRateProtocolGetComplianceRateTopCsvRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<PiracyCommonProtocolFileResponse, any>({
      path: `/performance/details/comp-rate/top-channel/csv`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Performance
   * @name DetailsOffenderCreate
   * @request POST:/performance/details/offender
   */
  detailsOffenderCreate = (data: PerfDetailsOffenderProtocolGetOffendersRequest, params: RequestParams = {}) =>
    this.http.request<PerfDetailsOffenderProtocolGetOffendersResponse, any>({
      path: `/performance/details/offender`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Performance
   * @name DetailsOffenderTopInfringingProfilesCreate
   * @request POST:/performance/details/offender/top-infringing-profiles
   */
  detailsOffenderTopInfringingProfilesCreate = (
    data: PerfDetailsOffenderProtocolGetTopInfringingProfilesRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<PerfDetailsOffenderProtocolGetTopInfringingProfilesResponse, any>({
      path: `/performance/details/offender/top-infringing-profiles`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Performance
   * @name DetailsOffenderTopInfringingDomainsCreate
   * @request POST:/performance/details/offender/top-infringing-domains
   */
  detailsOffenderTopInfringingDomainsCreate = (
    data: PerfDetailsOffenderProtocolGetTopInfringingDomainsRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<PerfDetailsOffenderProtocolGetTopInfringingDomainsResponse, any>({
      path: `/performance/details/offender/top-infringing-domains`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Performance
   * @name DetailsOffenderChannelFilterCreate
   * @request POST:/performance/details/offender/channel-filter
   */
  detailsOffenderChannelFilterCreate = (
    data: PerfDetailsOffenderProtocolGetChannelFilterListRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<PerfDetailsOffenderProtocolGetChannelFilterListResponse, any>({
      path: `/performance/details/offender/channel-filter`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Performance
   * @name DetailsOffenderTopInfringingProfilesCsvCreate
   * @request POST:/performance/details/offender/top-infringing-profiles/csv
   */
  detailsOffenderTopInfringingProfilesCsvCreate = (
    data: PerfDetailsOffenderProtocolGetTopInfringingProfilesCsvRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<PiracyCommonProtocolFileResponse, any>({
      path: `/performance/details/offender/top-infringing-profiles/csv`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Performance
   * @name DetailsOffenderTopInfringingDomainsCsvCreate
   * @request POST:/performance/details/offender/top-infringing-domains/csv
   */
  detailsOffenderTopInfringingDomainsCsvCreate = (
    data: PerfDetailsOffenderProtocolGetTopInfringingDomainsCsvRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<PiracyCommonProtocolFileResponse, any>({
      path: `/performance/details/offender/top-infringing-domains/csv`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
}
